import("../../../assets/js/splide.js")
	.then(({ Splide }) => {
		// Variables
		const sliders = document.querySelectorAll(".testimonial-slider .splide")

		// Initializing Splider
		for (let i = 0; i < sliders.length; i++) {
			new Splide(sliders[i], {
				type: "slide",
                arrows: true,
				pagination: true,
                perPage: 1
			}).mount()
		}
	})
	.catch((err) => {
		console.error(err)
	});